var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgZa = function SvgZa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 14"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#za-flag-clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D03034",
    d: "m4.207 0 7 4.665H24V0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.606 5.6H24v-.935H11.207zm-1.399 3.733H24v-.934H12.606l-1.4.934Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2D328E",
    d: "m11.207 9.333-7 4.667H24V9.333z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#010101",
    d: "M0 4.665h2.793L0 2.804zm0 0v4.668h2.793L6.293 7l-3.5-2.335zm0 4.668v1.863l2.793-1.863z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1B124",
    d: "M0 2.804 6.293 7 0 11.196v1.12L7.976 7 0 1.683z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#33784D",
    d: "M0 0v1.683L7.976 7 0 12.317V14h2.524l8.399-5.6H24V5.6H10.923L2.523 0z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "za-flag-clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v14H0z"
  })))));
};
export { SvgZa as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9Im5vbmUiIHZpZXdCb3g9IjAgMCAyNCAxNCI+PGcgY2xpcC1wYXRoPSJ1cmwoI3phLWZsYWctY2xpcC1wYXRoKSI+PHBhdGggZmlsbD0iI0QwMzAzNCIgZD0ibTQuMjA3IDAgNyA0LjY2NUgyNFYwSDQuMjA3WiIvPjxwYXRoIGZpbGw9IiNmZmYiIGQ9Ik0xMi42MDYgNS42SDI0di0uOTM1SDExLjIwN2wxLjM5OS45MzZaTTExLjIwNyA5LjMzM0gyNHYtLjkzNEgxMi42MDZsLTEuNC45MzRaIi8+PHBhdGggZmlsbD0iIzJEMzI4RSIgZD0ibTExLjIwNyA5LjMzMy03IDQuNjY3SDI0VjkuMzMzSDExLjIwN1oiLz48cGF0aCBmaWxsPSIjMDEwMTAxIiBkPSJNMCA0LjY2NWgyLjc5M0wwIDIuODA0djEuODYxWk0wIDQuNjY1djQuNjY4aDIuNzkzTDYuMjkzIDdsLTMuNS0yLjMzNUgwWk0wIDkuMzMzdjEuODYzbDIuNzkzLTEuODYzSDBaIi8+PHBhdGggZmlsbD0iI0YxQjEyNCIgZD0iTTAgMi44MDQgNi4yOTMgNyAwIDExLjE5NnYxLjEyTDcuOTc2IDcgMCAxLjY4M3YxLjEyWiIvPjxwYXRoIGZpbGw9IiMzMzc4NEQiIGQ9Ik0wIDB2MS42ODNMNy45NzYgNyAwIDEyLjMxN1YxNGgyLjUyNGw4LjM5OS01LjZIMjRWNS42SDEwLjkyM0wyLjUyMyAwSDBaIi8+PC9nPjxkZWZzPjxjbGlwUGF0aCBpZD0iemEtZmxhZy1jbGlwLXBhdGgiPjxwYXRoIGZpbGw9IiNmZmYiIGQ9Ik0wIDBoMjR2MTRIMHoiLz48L2NsaXBQYXRoPjwvZGVmcz48L3N2Zz4=";